



















































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import requestService from "@/service/requestService";
import { Action } from "vuex-class";
import { MESSAGE } from "@/model/Message";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { ElButton } from 'element-ui/types/button';

@Component({
  components: {
    Header,
    InputNumber
  }
})
export default class ReservationNumber extends Vue {
  reservationNo: string = "";
  reqService: requestService;
  message: string = "";
  arrNum: any = Array(4).fill(null);

  @Action("init", { namespace: "ReservationDetail" })
  initReservationDetail: any;

  @Action("clearState", { namespace: "ReservationDetail" })
  clearStateReservation: any;

  @Action("clearState", { namespace: "InspectSeibi" })
  clearStateStatusResult: any;

  @Action("clearState", { namespace: "Shohiyou" })
  clearStateShohiyou: any;

  @Action("clearState", { namespace: "Coupon" })
  clearStateCoupon: any;

  @Action("clearState", { namespace: "SubHeader" })
  clearStateTime: any;

  @Action("clearState", { namespace: "Payment" })
  clearPayment: any;

  @Action("clearState", { namespace: "UserDataState" })
  clearUserData: any;

  /** 2021-07-15 sh #6989 implement quick mitsumori search.(priority 2) [START] */
  @Action("clearState", { namespace: "FunctionSetting"} )
  clearStateFunctionSetting: any;

  @Action("clearState", { namespace: "Option"} )
  clearStateOption: any;
  /** 2021-07-15 sh #6989 implement quick mitsumori search.(priority 2) [END] */

  /** 2024-01-09 sh #8441(BQR1150) add loading for button mashing [START] */
  loadingText: string = MESSAGE.Loading;
  isLoading: boolean = false;
  /** 2024-01-09 sh #8441(BQR1150) add loading for button mashing [END] */

  constructor() {
    super();
  }

  created() {
    this.reqService = new requestService();
    this.clearStateTime();
    this.clearStateReservation();
    this.clearStateStatusResult();
    this.clearStateShohiyou();
    this.clearStateCoupon();
    this.clearPayment();
    this.clearUserData();
    /** 2021-07-15 sh #6989 implement quick mitsumori search.(priority 2) [START] */
    this.clearStateOption();
    /**
      2021-08-19 sh 会社情報が変わるわけではないので、ここで、クリアは不要だと思う。
      もしいったんクリアが必要な場合、再読込すればよいかと思う。
      */
    // this.clearStateFunctionSetting();
    /** 2021-07-15 sh #6989 implement quick mitsumori search.(priority 2) [END] */
  }

  addNum(num: number) {
    const index = this.arrNum.findIndex((e: any) => e == null);
    if (index > 0) {
      this.arrNum[index] = num;
    }
    this.$set(this.arrNum, index, num);
    if (index === 3) {
      this.focusStart();
    }
  }

  onEnter(index: number) {
    if (index === 3) {
      this.focusStart();
    }
  }

  focusStart() {
    const btn = document.getElementById("btn-start");
    if (btn) {
      btn.focus();
    }
  }

  focusInput(index: number) {
    const div = document.getElementById("num" + index);
    if (div && div.children.length == 1) {
      setTimeout(() => {
        const input = div.children[0] as HTMLElement;
        input.focus();
      });
    }
  }

  onClear() {
    let clearIndex = this.arrNum.length - 1;
    for (let i = this.arrNum.length - 1; i >= 0; i--) {
      if (this.arrNum[i] != null) {
        clearIndex = i;
        this.focusInput(i);
        break;
      }
    }
    this.$set(this.arrNum, clearIndex, null);
  }

  onStart() {
    if (this.arrNum.every((e: any) => e != null)) {
      this.reservationNo = this.arrNum.join("");
      /** 2024-01-09 sh #8441(BQR1150) add loading for button mashing [START] */
      this.$set(this, "isLoading", true);
      /** 2024-01-09 sh #8441(BQR1150) add loading for button mashing [END] */
      this.reqService
        .getReservationDetail(this.reservationNo, true)
        .then(
          (res: any) => {
            if (res) {
              if (res.uketsuke.progressKbn == 3 || res.uketsuke.delKbn == 9) {
                this.message = MESSAGE.ReservationCancel;
              } else {
                this.initReservationDetail(res);
                this.$router.push(`customer/${this.reservationNo}`);
              }
            }
            /** 2024-01-09 sh #8441(BQR1150) add loading for button mashing [START] */
            this.$set(this, "isLoading", false);
            /** 2024-01-09 sh #8441(BQR1150) add loading for button mashing [END] */
          },
          (err: any) => {
            /** 2024-01-09 sh #8441(BQR1150) add loading for button mashing [START] */
            this.$set(this, "isLoading", false);
            /** 2024-01-09 sh #8441(BQR1150) add loading for button mashing [END] */
            if (err.status == 204) {
              this.message = MESSAGE.NoData;
            /** 2021-03-02 sh #6910 check expiration of yoyaku number [START] */
            } else if (err.status == 401) {
              this.message = MESSAGE.YoyakuNoisExpired;
            /** 2021-03-02 sh #6910 check expiration of yoyaku number [END] */
            } else if (err.status < 500 && err.rsltComment) {
              this.message = err.rsltComment;
            } else {
              this.message = MESSAGE.SystemError;
            }
          }
        )
        .catch(error => {});
    }
  }

  gotoQuickMisumori() {
    this.$router.push({ name: "quickmitsumorilist" });
  }
}
